export default [
  {
    path: "/kehamilan",
    component: () => import("@/pages/kehamilan/kehamilan-list.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
  {
    path: "/kehamilan/import/",
    component: () => import("@/pages/kehamilan/kehamilan-import.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
  {
    path: "/kehamilan/update/:id",
    component: () => import("@/pages/kehamilan/kehamilan-form.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
];
